var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full fixed inset-0 z-50 my-auto bg-smoke flex items-center justify-center loader",class:[(_vm.getterLoaderShow) ? 'static' : 'hidden'],attrs:{"id":"loader"}},[_c('div',{staticClass:"spinnerx"})])}
var staticRenderFns = []

export { render, staticRenderFns }